import React, { useEffect, useState } from "react"
import MetaTags from 'react-meta-tags';
import { 
  Col,
  Container,
  Row,
  Card,
  CardBody,
  Form,
  Table,
  Input,
  Button,
  InputGroup,
 } from "reactstrap"
import { connect, useDispatch } from "react-redux";
import { withRouter, Link} from "react-router-dom";
//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb"
import Loader from "../../components/Common/Loader"
import Pagination from "../../components/Common/Pagination"

import { lengsList, lengsFilter } from "../../store/lengs/actions"

const Lengs = (props) => {
  const dispatch = useDispatch();

  const [search, setSearch] = useState("");

  const onChange = (e) => {
    setSearch(e.target.value);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    dispatch(lengsFilter(`?search=${search}`));
  };

  const resetSearch = () => {
    dispatch(lengsFilter(`?search=`));
    setSearch("");
  };


  useEffect(() => {

    dispatch(lengsList())

  }, [dispatch])

  const params = {
    count: props.lengs.count,
    next: props.lengs.next,
    previous: props.lengs.previous,
    results: props.lengs.results,
  };

console.log(params.results);
  return (
    <React.Fragment>
      <div className="page-content">
        <MetaTags>
          <title>  | Prospectos </title>
        </MetaTags>
        <Container fluid>
          {/* Render Breadcrumbs */}
          <Breadcrumbs title="" breadcrumbItem=" Prospectos " />

          {props.loading ? (
            <Loader />
          ) : (
            <div>
              <Card>
                <CardBody>
                  <Row>
                    <Col md={7}>
                      <Link
                        className="btn btn-primary waves-effect waves-light mb-1"
                        to="/lengs/create"
                      >
                        Agregar
                      </Link>
                    </Col>
                    <Col md={5}>
                      <Form className="search-box" onSubmit={onSubmit}>
                        <InputGroup>
                          <Input
                            type="text"
                            className="form-control"
                            name="search"
                            placeholder="Documento, Nombre, Agente..."
                            value={search}
                            onChange={onChange}
                          />
                          <i className="bx bx-search-alt search-icon" />
                          <Button color="primary" onClick={resetSearch}>
                            <span className=" bx bx-x fa-lg align-middle"></span>
                          </Button>
                        </InputGroup>
                      </Form>
                    </Col>
                  </Row>
                </CardBody>
              </Card>
              <Card>
                {params.results ? (
                  <CardBody className="ps-5 pe-5">
                    <h2 className="mb-3 font-size-20">Lista de Cuentas</h2>
                    <div className="table-responsive">
                      <Table
                        className="table table-sm table-borderless table-striped align-middle table-centered table-nowrap mb-3"
                        style={{
                          textAlign: "center",
                        }}
                      >
                        <thead className="table-light">
                          <tr>
                            <th>#</th>
                            <th>Nombre y Apellido</th> 
                            <th>Documento</th>                            
                            <th>Correo Electrónico</th>
                            <th>Genero</th>
                            <th>Fecha de Nacimiento</th>
                            <th>Ciudad</th>
                            <th>Observaciones</th>
                            <th>Agente</th>
                            <th>Acción</th>
                          </tr>
                        </thead>
                        <tbody>
                          {params.results.map((lengs, idx ) => (
                            
                            <tr key={idx}>
                              <th scope="row">{ idx+1 }</th>
                              <td>{lengs.first_name} {lengs.last_name}</td>                              
                              <td>{lengs.documentNumber}</td>
                              <td>{lengs.email}</td>
                              <td>{lengs.gender}</td>
                              <td>{lengs.birthdate}</td>
                              <td>{lengs.city}</td>
                              <td>{lengs.observations}</td>
                              {Array.isArray(lengs.agent) && !lengs.agent.length ?(                                                         
                              <td>
                                <Button className="btn-sm btn-success">Asignar</Button>
                              </td>
                              ):
                              <td>{lengs.agent}</td>
                              }
                              
                              <td>
                                <Link to={`/lengs/update/${lengs.id}`}>
                                  <span className="bx bx-edit fa-lg align-middle"></span>
                                </Link>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </Table>
                    </div>
                    <Pagination
                      count={params.count}
                      next={params.next}
                      previous={params.previous}
                      limit={10}
                      baseUrl="produccion/lengs/"
                      filterFunction={lengsFilter}
                    />
                  </CardBody>
                ) : (
                  <CardBody>
                    <h4 className="card-title">No se encontraron resultados</h4>
                  </CardBody>
                )}
              </Card>
            </div>
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}


const mapStateToProps = (state) => {
  const { error, loading, lengs } = state.Lengs;
  return { error, loading, lengs };
};

export default withRouter(connect(mapStateToProps)(Lengs));
